import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    posPaySettings: {
        cash: true,
        deposit: false,
        remittance: true,
        tapPay: false,
        line: false,
        jko: false,
    },
};

const posPaySettingsSlice = createSlice({
    name: "posPaySettings",
    initialState: initialState,
    reducers: {
        // 登入 
        setPosPaySettings(state, action) {
            const { cash, deposit, remittance, tapPay, line, jko } = action.payload;
            state.posPaySettings.cash = cash;
            state.posPaySettings.deposit = deposit;
            state.posPaySettings.remittance = remittance;
            state.posPaySettings.tapPay = tapPay;
            state.posPaySettings.line = line;
            state.posPaySettings.jko = jko;
        },
        // 登出
        setLogoutForPosPaySettings(state) {
            state.posPaySettings = {
                ...initialState.posPaySettings,
            };
        },
        // 更新
        updatePosPaySettings(state, action) {
            // console.log(action);
            const { eng: chosenSetting, newValue } = action.payload;
            switch (chosenSetting) {
                case 'cash':
                    state.posPaySettings.cash = newValue;
                    break;
                case 'deposit':
                    state.posPaySettings.deposit = newValue;
                    break;
                case 'remittance':
                    state.posPaySettings.remittance = newValue;
                    break;
                case 'tapPay':
                    state.posPaySettings.tapPay = newValue;
                    break;
                case 'line':
                    state.posPaySettings.line = newValue;
                    break;
                case 'jko':
                    state.posPaySettings.jko = newValue;
                    break;
                default:
                    break;
            }
        }
    },
});

export const {
    setPosPaySettings,
    setLogoutForPosPaySettings,
    updatePosPaySettings
} = posPaySettingsSlice.actions;

export default posPaySettingsSlice.reducer;